
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Enum.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum MessageType {
	CommunicationLogEntryChanged = 0,
	MailTemplateChanges = 1,
	NotificationChanges = 2,
	ProductChange = 3,
	QuestionnaireQuestionChange = 4,
	QuestionReplyChange = 5,
	OrderChanges = 6,
	SaleAgreementChange = 7,
	CompanyChanges = 8,
	TaskflowTemplateChanges = 9,
	TaskflowChanges = 10,
	UserChanges = 11,
	TeamChanges = 12,
	SiteChanges = 13,
	CrayonChanges = 14,
	PoolChanges = 16,
	WorkflowTemplateChanges = 17,
	ProductPlanChanges = 18,
	AccountingPlanChanges = 19,
	AccountingPlanSetupChanges = 20,
	PriceAdjustmentChanges = 21,
	MicrosoftSubscriptionChanged = 22,
	ProductPlanSettingChanges = 23,
	BillingPlanChanges = 24,
	QuestionnaireChange = 25,
	InvoiceChanges = 26,
	ReasonChanges = 27,
	ReasonCategoryChanges = 28,
	SettlementChanges = 29,
	FileReferenceChanges = 30,
	DomainChanges = 31,
	InstallmentPaymentChanges = 32,
	DashboardChanges = 33
}
export namespace MessageType {
	export function getKeys(): Map<MessageType, string> {
		return new Map([[0, 'CommunicationLogEntryChanged'], [1, 'MailTemplateChanges'], [2, 'NotificationChanges'], [3, 'ProductChange'], [4, 'QuestionnaireQuestionChange'], [5, 'QuestionReplyChange'], [6, 'OrderChanges'], [7, 'SaleAgreementChange'], [8, 'CompanyChanges'], [9, 'TaskflowTemplateChanges'], [10, 'TaskflowChanges'], [11, 'UserChanges'], [12, 'TeamChanges'], [13, 'SiteChanges'], [14, 'CrayonChanges'], [16, 'PoolChanges'], [17, 'WorkflowTemplateChanges'], [18, 'ProductPlanChanges'], [19, 'AccountingPlanChanges'], [20, 'AccountingPlanSetupChanges'], [21, 'PriceAdjustmentChanges'], [22, 'MicrosoftSubscriptionChanged'], [23, 'ProductPlanSettingChanges'], [24, 'BillingPlanChanges'], [25, 'QuestionnaireChange'], [26, 'InvoiceChanges'], [27, 'ReasonChanges'], [28, 'ReasonCategoryChanges'], [29, 'SettlementChanges'], [30, 'FileReferenceChanges'], [31, 'DomainChanges'], [32, 'InstallmentPaymentChanges'], [33, 'DashboardChanges']]);
	}
}
